import { useState } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "motion/react";

import Squiggle from "./Squiggle";
import FnrShineButton from "../../FnrShineButton";

export default function SectionTitle({
  tabKey,
  title,
  icon,
  onClick,
  color,
  anyOtherTabIsOpen = false,
  open = false,
  hasSettings = false,
  ...props
}) {
  const [tapping, setTapping] = useState(false);
  const [hovering, setHovering] = useState(false);

  const hoverStart = (e) => {
    setHovering(true);
  };
  const hoverEnd = (e) => {
    setHovering(false);
  };

  const tapStart = () => setTapping(true);
  const tapEnd = () => setTapping(false);

  return (
    <Container>
      <TitleWrapper
        onHoverStart={hoverStart}
        onHoverEnd={hoverEnd}
        onTapStart={tapStart}
        onTapCancel={tapEnd}
        onTap={tapEnd}
        onClick={onClick}
        {...props}
      >
        <Inside>
          <ContentAround
            animate={{
              scale: tapping ? 0.96 : 1,
            }}
          >
            <Icon animate={{ fontSize: anyOtherTabIsOpen ? "18px" : "24px" }}>
              <i className={icon} />
            </Icon>
            <Title
              className="raleway"
              animate={{ fontSize: anyOtherTabIsOpen ? "16px" : "20px" }}
            >
              {title}
            </Title>
          </ContentAround>
          <Squiggle
            color={open ? "#FFFFFF" : color}
            show={hovering || open}
            anyOtherTabIsOpen={anyOtherTabIsOpen}
            tabKey={tabKey}
          />
        </Inside>
      </TitleWrapper>
      {hasSettings && (
        <AnimatePresence>
          {open && (
            <SettingsWrapper
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
            >
              <FnrShineButton>
                <SettingsIconHolder>
                  <i className="fas fa-gear" />
                </SettingsIconHolder>
              </FnrShineButton>
            </SettingsWrapper>
          )}
        </AnimatePresence>
      )}
    </Container>
  );
}

const Container = styled.div`
  position: relative;
`;
const TitleWrapper = styled(motion.div)`
  border-radius: 24px;
  cursor: pointer;
  position: relative;
  appearance: none;
  border: none;
  transition: filter 0.2s;
`;
const Inside = styled(motion.div)`
  border-radius: 24px;
  display: flex;
  height: 100%;
  align-items: center;
  position: relative;
  z-index: 5;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 12px;
  transform-origin: 0% 50%;
`;
const ContentAround = styled(motion.div)`
  z-index: 40;
  position: relative;
  width: 100%;
  color: #fff;
  font-weight: 400;
  user-select: none;
  font-size: 20px;
  line-height: 1.1em;
  text-shadow: rgba(0, 0, 0, 0.2) 1px 1px 2px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Icon = styled(motion.div)`
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
`;
const Title = styled(motion.div)``;
const SettingsWrapper = styled(motion.div)`
  position: absolute;
  right: 10px;
  top: 10px;
`;
const SettingsIconHolder = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  font-weight: 400;
  text-shadow: rgba(0, 0, 0, 0.2) 1px 1px 2px;
`;
